var caller;

// TODO:  Firstly store cached, less accurate location and then try to fetch this max accurate location
function storeLocation(e, callback = null) {
    caller = e;
    if (navigator.geolocation) {
        DisableRegions();
        navigator.geolocation.getCurrentPosition(function (position) {
            locationObtained(position);
            if (callback) callback();
        }, function () {
            locationNotObtained();
            if (callback) callback();
        }, {
            maximumAge: 0,
            enableHighAccuracy: true
        });
    } else {
        locationNotObtained();
        if (callback) callback();
    }
};

function initializeGeolocationAvailability(availableCallback = null) {
    navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
        if (permissionStatus.state == 'granted') {
            availableCallback();
        }
        permissionStatus.onchange = function () {
            navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
                if (permissionStatus.state == 'granted') {
                    availableCallback();
                }
            })
        };
    });
}

function locationObtained(position) {
    $('#share-location-label').text('Hledat inzeráty v okolí');
    $('.js-geolocation-input').val(position.coords.latitude + ',' + position.coords.longitude);
}

function locationNotObtained() {
    EnableRegions();
    caller.prop('checked', false);
    $('#share-location-label').text('Polohu se nepodařilo získat.');
}

function removeLocation() {
    $('.js-filter-input-wrapper-location :input').prop('disabled', false);
}

function DisableRegions() {
    var regionsInputs = $('.js-filter-input-wrapper-location :input').prop('disabled', true);
    regionsInputs.prop('disabled', true);
    regionsInputs.prop('checked', false);
}

function EnableRegions() {
    var regionsInputs = $('.js-filter-input-wrapper-location :input').prop('disabled', true);
    regionsInputs.prop('disabled', false);
}